import { DownloadNotification } from "../../components/Layout/components/Header/components/Notifications/hooks/useNotifications/useNotifications";
import { PROMOTION_PARTS_DETAIL_DOWNLOAD } from "../../utils/constants";
import { DOWNLOAD_JOB_COMPLETE, NOTIFY } from "../../utils/eventConstants";
import {
  PendingPromotionCompilationJob,
  removeCompletedPromotionCompilationJobs,
  removeExpiredPromotionCompilationJobs,
} from "../../utils/promotions/promotionUtils";
import {
  PromotionCompilationCompletedJobStatus,
  PromotionCompilationJobStatus,
} from "../usePromotionDownloadStatus/usePromotionDownloadStatus";

const raisePromotionCompileJobCompleteEvent = (
  downloadedPromotionIds: string[]
): void => {
  window.dispatchEvent(
    new CustomEvent(DOWNLOAD_JOB_COMPLETE, {
      bubbles: true,
      detail: {
        downloadedPromotionIds,
      },
    })
  );
};

const raisePromotionCompileNotificationEvent = (
  payload: DownloadNotification
): void => {
  window.dispatchEvent(
    new CustomEvent(NOTIFY, {
      bubbles: true,
      detail: payload,
    })
  );
};

export const filterCompletedJobStatuses = (
  downloadStatuses: PromotionCompilationJobStatus[]
): PromotionCompilationCompletedJobStatus[] =>
  downloadStatuses.filter(
    (job) => job.status !== "IN_PROGRESS"
  ) as PromotionCompilationCompletedJobStatus[];

export const publishCompletedPromotionCompilationJobStatuses = (
  completedJobStatuses: PromotionCompilationCompletedJobStatus[]
) => {
  if (completedJobStatuses.length > 0) {
    raisePromotionCompileJobCompleteEvent(
      completedJobStatuses.map((job) => job.promotionId)
    );
    completedJobStatuses.forEach((job) => {
      raisePromotionCompileNotificationEvent({
        id: job.jobId,
        filename: job.promotionId,
        downloadUrl: job.downloadUrl,
        compilationStatus: job.status,
        type: PROMOTION_PARTS_DETAIL_DOWNLOAD,
      });
    });
  }
};

export const publishExpiredPromotionCompilationJobStatuses = (
  expiredJobs: PendingPromotionCompilationJob[]
) => {
  if (expiredJobs.length > 0) {
    raisePromotionCompileJobCompleteEvent(
      expiredJobs.map((job) => job.promotionId)
    );
    expiredJobs.forEach((job) => {
      raisePromotionCompileNotificationEvent({
        id: job.jobId,
        filename: job.promotionId,
        downloadUrl: null,
        compilationStatus: "FAILED",
        type: PROMOTION_PARTS_DETAIL_DOWNLOAD,
      });
    });
  }
};

export const removeCompletedAndExpiredPromotionCompilationJobs = (
  accountId: string,
  completedJobStatuses: PromotionCompilationCompletedJobStatus[],
  PROMOTION_DOWNLOAD_JOB_TIMEOUT: number
): {
  remainingJobs: PendingPromotionCompilationJob[];
  expiredJobs: PendingPromotionCompilationJob[];
} => {
  const remainingJobs = removeCompletedPromotionCompilationJobs(
    accountId,
    completedJobStatuses.map((job) => job.jobId)
  );
  const { expiredJobs, validJobs } = removeExpiredPromotionCompilationJobs(
    accountId,
    remainingJobs,
    PROMOTION_DOWNLOAD_JOB_TIMEOUT
  );
  return { remainingJobs: validJobs, expiredJobs };
};
